import i18nMain from './i18nMain';
import i18nValidate from './i18nValidate';
import i18nTable from './i18nTable';
import i18nCommon from './i18nCommon';
import i18nEnum from './i18nEnum';
import i18nComponent from './i18nComponent';
import i18nColumn from './i18nColumn';
import i18nPages from './i18nPages';
import i18nColumnTemplate from './i18nColumnTemplate';
import i18nBaseForm from './i18nBaseForm';
import i18nAccountingObject from './dictionary/i18nAccountingObject';
import i18nStock from './dictionary/i18nStock';
import i18nEmployee from './dictionary/i18nEmployee';
import i18nLicense from './dictionary/i18nLicense';
import i18nLeftMenu from './dictionary/i18nLeftMenu';
import i18nRequest from './dictionary/i18nRequest';
import i18nSettings from './dictionary/i18nSettings';
import i18nTickets from './dictionary/i18nTickets';
import i18nPartner from './dictionary/i18nPartner';

export default {
  i18nMain,
  i18nValidate,
  i18nCommon,
  i18nComponent,
  i18nEnum,
  i18nColumn,
  i18nPages,
  i18nBaseForm,
  i18nColumnTemplate,
  i18nTable,
  i18nStock,
  i18nAccountingObject,
  i18nEmployee,
  i18nLicense,
  i18nSettings,
  i18nRequest,
  i18nLeftMenu,
  i18nTickets,
  i18nPartner
};
